// Generated by CoffeeScript 2.7.0
var CurrentAttributes;

import CurrentUser from './current_user.js';

import CurrentNamespace from './current_namespace.js';

export default CurrentAttributes = {
  currentAttributesList: [],
  init: function() {
    return this._initCurrentAttributes();
  },
  destruct: function() {
    return this._resetAll();
  },
  _initCurrentAttributes: function() {
    window.currentUser = new CurrentUser();
    window.currentNamespace = new CurrentNamespace();
    this.currentAttributesList.push(window.currentUser);
    return this.currentAttributesList.push(window.currentNamespace);
  },
  _resetAll: function() {
    var ca, i, len, ref, results;
    ref = this.currentAttributesList;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      ca = ref[i];
      results.push(ca.resets());
    }
    return results;
  }
};
